import { render, staticRenderFns } from "./AbsencesEditorEmployee.vue?vue&type=template&id=45ebad20&scoped=true&lang=pug&"
import script from "./AbsencesEditorEmployee.vue?vue&type=script&lang=ts&"
export * from "./AbsencesEditorEmployee.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45ebad20",
  null
  
)

export default component.exports